import React, { useEffect, useMemo, useRef, useState } from "react";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";
import ReusableGrid from "../../../components/ag grid/ReusableGrid";

const EmployerPermissionsTab = ({
  modulesData,
  permissions,
  setPermissions,
  formik
}) => {
  const gridRef = useRef();
  const isMobile = window.innerWidth < 600;
  const [allActions, setAllActions] = useState([]);
  const [gridHeight, setGridHeight] = useState(400);
  const [pageSize, setPageSize] = useState(5);
  
  // Flatten incoming module data into row format
  useEffect(() => {
    if (!modulesData) return;

    const allActionKeys = new Set();
    modulesData.forEach((mod) => {
      mod.actions.forEach((act) => allActionKeys.add(act.key));
    });

    setAllActions([...allActionKeys]);
  }, [modulesData]);

  useEffect(() => {
  const calculateHeight = () => {
    const windowHeight = window.innerHeight; // Full viewport height
    const offset = 250; // Height taken by header/footer/margins
    const calculatedHeight = windowHeight - offset;
    setGridHeight(calculatedHeight);
  };

  calculateHeight(); // run on mount

  window.addEventListener("resize", calculateHeight);
  return () => window.removeEventListener("resize", calculateHeight);
}, []);


  // const handleToggle = (module, field, value) => {
  //   setPermissions((prev) =>
  //     prev.map((row) => {
  //       if (row.module !== module) return row;

  //       if (field === "enabled") {
  //         // When enabling, optionally turn on 'view'
  //         const updated = { ...row, enabled: value };
  //         allActions.forEach((action) => {
  //           updated[action] = value ? action === "view" : false;
  //         });
  //         return updated;
  //       }

  //       return { ...row, [field]: value };
  //     })
  //   );
  // };

  const handleToggle = (module, field, value) => {
    setPermissions((prev) => {
      const updatedData = prev.map((row) => {
        if (row.module !== module) return row;

        if (field === "enabled") {
          const updated = { ...row, enabled: value };
          allActions.forEach((action) => {
            updated[action] = value ? action === "view" : false;
          });

          return updated;
        }

        return { ...row, [field]: value };
      });

      // Scroll to the modified row after updating state
      setTimeout(() => {
        const rowIndex = updatedData.findIndex((r) => r.module === module);
        if (gridRef.current && gridRef.current.ensureIndexVisible) {
          gridRef.current.ensureIndexVisible(rowIndex, "middle"); // Scrolls that row into view
        }
      }, 0);

      return updatedData;
    });
  };

  const actionRenderer = (field) => (params) =>
    (
      <Checkbox
        checked={params.data[field] || false}
        onChange={(e) =>
          handleToggle(params.data.module, field, e.target.checked)
        }
        disabled={!params.data.enabled}
      />
    );

  const columnDefs = useMemo(() => {
    const baseColumns = [
      {
        headerName: "Module",
        field: "moduleLabel",
        pinned: "left",
        cellClass: "wrap-text",
        autoHeight: true,
        cellRenderer: (params) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <Switch
              size="small"
              checked={params.data.enabled}
              onChange={(e) =>
                handleToggle(params.data.module, "enabled", e.target.checked)
              }
            />
            <span>
              {params.data.moduleLabel}
              {/* {params.data.moduleLabel
        .split(" ")
        .map((word, idx) => (
          <React.Fragment key={idx}>
            {word}
            <br />
          </React.Fragment>
        ))} */}
            </span>
          </div>
        ),
        minWidth: isMobile ? 150 : 200,

        suppressSizeToFit: false // important for autoSize
      }
    ];

    const actionColumns = allActions.map((action) => ({
      headerName: action
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase()),
      field: action,
      cellRenderer: actionRenderer(action),
      flex: 1
    }));

    return [...baseColumns, ...actionColumns];
  }, [allActions, permissions]);

  return (
    <div style={{ overflowX: "auto", width: "100%", flex: 1 }}>
      <div
        className="permission-grid-wrapper"
        
      >
        <ReusableGrid
          rowData={permissions}
          columnDefs={columnDefs}
          pagination={true}
          gridRef={gridRef}
          domLayout="normal"
          height={`${gridHeight}px`}
          pageSize={pageSize}
        />
      </div>
    </div>
  );
};

export default EmployerPermissionsTab;
